import { createFileRoute } from "@tanstack/react-router";
import { MoveHelpPage } from "@/features/marketing/move-help-page";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/help/move")({
  head: SEO.move,
  component: MoveHelpPage,
});
